<template>
  <b-modal
    id="animal-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un animal"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
  >
    <div v-if="selectedAnimal !== null">
      <div>
        Retirer {{selectedAnimal.name}} de la base de données ?
      </div>
      <div>
        Vous allez supprimer toutes les hospitalisations, les chirurgies et données associées à cet animal.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'animal-delete-modal',

  props: {
    selectedAnimal: Object
  },

  emits: ['didDeleteAnimal'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      api
        .delete(`/animal/${this.selectedAnimal.id}`)
        .then(response => {
          this.$emit('didDeleteAnimal')
          this.hideModal()
          this.successToast()
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('animal-delete-modal')
    },

    successToast() {
      this.$bvToast.toast(`Animal supprimé`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/animal/AnimalDeleteModal.vue